export const CASES = [
  {
    id: "drogaria-saude-mais",
    sector: "Farmácia",
    color: "bg-red-500/15 text-red-400 border-red-500/30",
    company: "Drogaria Saúde+",
    location: "São Paulo · 4 unidades",
    headline: "Reduziu ruptura em 58% e elevou margem em 7pp",
    challenge: "Ruptura média de 14% em medicamentos críticos. Compras baseadas em planilhas atualizadas semanalmente.",
    solution: "Implementou previsão de demanda IA + alertas críticos + Copiloto IA para análise diária.",
    results: [
      { metric: "Ruptura", before: "14%", after: "5,9%", delta: "-58%" },
      { metric: "Capital parado", before: "R$ 220k", after: "R$ 95k", delta: "-57%" },
      { metric: "Margem bruta", before: "32%", after: "39%", delta: "+7pp" },
      { metric: "Tempo gasto em compras", before: "12h/sem", after: "3h/sem", delta: "-75%" },
    ],
    quote: "Antes eu vivia apagando incêndio. Hoje o sistema avisa antes do incêndio começar.",
    author: "Mariana Costa, Diretora",
    period: "120 dias",
  },
  {
    id: "mercado-bairro-rj",
    sector: "Supermercado",
    color: "bg-blue-500/15 text-blue-400 border-blue-500/30",
    company: "Mercado do Bairro",
    location: "Rio de Janeiro · 1 unidade",
    headline: "Liberou R$ 80 mil em capital de giro em 60 dias",
    challenge: "Pequeno mercado familiar com R$ 180 mil de estoque, sendo 30% sem giro há mais de 60 dias.",
    solution: "Detector de estoque parado + sugestões de combo e liquidação progressiva via Copiloto IA.",
    results: [
      { metric: "Capital parado", before: "R$ 54k", after: "R$ -26k", delta: "Liberou R$ 80k" },
      { metric: "Itens sem giro", before: "147", after: "31", delta: "-79%" },
      { metric: "Faturamento", before: "R$ 88k/m", after: "R$ 102k/m", delta: "+16%" },
    ],
    quote: "O dinheiro estava ali, na prateleira. Eu só não estava vendo.",
    author: "Rafael Lopes, Sócio",
    period: "60 dias",
  },
  {
    id: "ecommerce-moda-mg",
    sector: "Moda",
    color: "bg-pink-500/15 text-pink-400 border-pink-500/30",
    company: "Closet Moderno",
    location: "Belo Horizonte · E-commerce",
    headline: "Sincronização Bling + 38% mais conversão",
    challenge: "Dados defasados entre Bling e site, vendia produto que não tinha estoque, gerando cancelamentos.",
    solution: "Webhook Bling → SmartStockAI atualiza estoque em < 200ms a cada pedido. Alertas pré-Black Friday.",
    results: [
      { metric: "Cancelamentos por ruptura", before: "8,2%", after: "0,4%", delta: "-95%" },
      { metric: "Conversão de site", before: "1,9%", after: "2,6%", delta: "+38%" },
      { metric: "NPS", before: "42", after: "71", delta: "+29 pts" },
    ],
    quote: "Integrei em 10 minutos. Cada venda agora atualiza o estoque sozinho.",
    author: "Juliana Reis, Gerente",
    period: "90 dias",
  },
  {
    id: "petshop-rede",
    sector: "Pet Shop",
    color: "bg-yellow-500/15 text-yellow-400 border-yellow-500/30",
    company: "PetCare Brasil",
    location: "Curitiba · 6 unidades",
    headline: "Multi-loja unificada e 22% de aumento em margem",
    challenge: "6 lojas com gestões independentes. Difícil enxergar onde tinha excesso e onde faltava.",
    solution: "Gestão multi-loja + transferências sugeridas pelo Copiloto + benchmarking entre unidades.",
    results: [
      { metric: "Excesso transferido entre lojas", before: "R$ 0", after: "R$ 145k/ano", delta: "Novo" },
      { metric: "Margem bruta consolidada", before: "37%", after: "45%", delta: "+8pp" },
      { metric: "Decisões/dia (gerente regional)", before: "2-3", after: "12+", delta: "+400%" },
    ],
    quote: "Vejo as 6 lojas como uma só operação. Faz toda a diferença.",
    author: "Carla Mendes, Sócia",
    period: "180 dias",
  },
  {
    id: "construrio-eletronicos",
    sector: "Eletrônicos",
    color: "bg-purple-500/15 text-purple-400 border-purple-500/30",
    company: "TechZone Eletro",
    location: "Porto Alegre · 2 unidades",
    headline: "Simulador de impacto guiou Black Friday histórica",
    challenge: "Black Friday anterior teve excesso de estoque pós-evento e produtos esgotados antes do tempo.",
    solution: "Simulador de impacto testou 12 cenários de preço × marketing antes do evento.",
    results: [
      { metric: "Faturamento Black Friday", before: "R$ 380k", after: "R$ 612k", delta: "+61%" },
      { metric: "Sobra pós-evento", before: "R$ 92k", after: "R$ 18k", delta: "-80%" },
      { metric: "Produtos com ruptura", before: "23", after: "4", delta: "-83%" },
    ],
    quote: "Pela primeira vez, minha Black Friday foi planejada — não improvisada.",
    author: "Bruno Silva, Diretor",
    period: "30 dias",
  },
];

export const findCase = (id) => CASES.find((c) => c.id === id);
